/**
 * Accumulate Message
 * Builds a message with a list of items asynchronously, then executes callback
 * from last invocation
 * e.g.
 * accumulateMessage('Hi ', 'Alice', console.log)
 * accumulateMessage('Hi ', 'Bill', console.log)
 * → 'Hi Alice, Bill'
 */

const accumulators = {}

export function accumulateMessage(message, item, callback, wait = 0) {
  if (!accumulators[message]) {
    accumulators[message] = { items: [] }
  }
  const acc = accumulators[message]
  clearTimeout(acc.timeout)
  acc.items.push(item)
  acc.timeout = setTimeout(() => {
    const output = `${message.replace('##', acc.items.length)}${acc.items.join(', ')}`
    callback(output)
    delete accumulators[message]
  }, wait)
}
